import React from 'react';
import slugify from 'slugify';

export const getMaxNumberOfProducts = function getMaxNumberOfProducts(
  firstLevelPages
) {
  let max = 0;

  if (firstLevelPages?.length > 0) {
    for (const firstLevelPage of firstLevelPages) {
      let linkFirstLevelPage = getLinkInformation(
        firstLevelPage.content.firstLevelInternalLink?.value?.link,
        firstLevelPage.content.firstLevelExternalLink.value,
        firstLevelPage.value,
        firstLevelPage.content.firstLevelInternalLink?.value?.pageTitle?.value
      );
      if (!linkFirstLevelPage.link) {
        if (firstLevelPage.content.secondLevelPages?.length > 0) {
          for (const secondLevelPage of firstLevelPage.content
            .secondLevelPages) {
            if (secondLevelPage.content.thirdLevelPages?.length > 0) {
              if (secondLevelPage.content.thirdLevelPages.length > max) {
                max = secondLevelPage.content.thirdLevelPages.length;
              }
            }
          }
        }
      }
    }
  }

  return max;
};

export const getMegaByteFromByte = function getMegaByteFromByte(bytes) {
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return '0 Byte';
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
};

export const getColorsCategory = function getColorsCategory(categories) {
  const colors = { primary: '', secondary: '', nameCategory: '' };

  if (categories?.length > 0) {
    for (const category of categories) {
      if (category?.description) {
        let nameCategory = category.name;
        let primary = category?.description?.split(',')[0]?.split('=')[1];
        let secondary = category?.description?.split(',')[1]?.split('=')[1];
        if (primary || secondary) {
          return { primary, secondary, nameCategory };
        }
      }
    }
  }

  return colors;
};

export const getBlogCategoryColor = function getBlogCategoryColor(category) {
  return `var(${category?.description?.split('=')[1]})`;
};

export const getLinkInformation = function getLinkInformation(
  internalLink,
  externalLink,
  labelLink,
  pageTitle
) {
  const linkData = { link: null, label: '' };

  if ((externalLink !== '' && internalLink !== '') || externalLink !== '') {
    linkData.link = externalLink;
    if (labelLink !== '') {
      linkData.label = labelLink;
    } else {
      linkData.label = externalLink;
    }
  } else if (internalLink !== '') {
    linkData.link = internalLink;
    if (labelLink !== '') {
      linkData.label = labelLink;
    } else {
      linkData.label = pageTitle;
    }
  } else {
    linkData.link = null;
  }

  return linkData;
};

export const getCommonOrganismData = (data) => {
  const htmlTagWrapper = data?.htmlTagWrapper?.value[0] || 'div';
  const backgroundColor = data?.backgroundColor?.value[0] || 'transparent';
  const anchorLabel =
    (data?.anchorLabel?.value &&
      slugify(data?.anchorLabel?.value, {
        lower: true, // forces lowercase
        strict: true, // strips special characters
      })) ||
    null;

  const titleData = data?.moduleTitle || {};
  const title = titleData?.value || '';
  const titleHeadingTag =
    data?.moduleTitle?.content?.headingTag?.value[0] || 'h1';
  const titleIconId = data?.moduleTitle?.content?.iconSvgIdTitle?.value || '';
  const marginTop = data?.marginTop?.value[0] || 'module-top-gap';
  const titleIconThickness =
    data?.moduleTitle?.content?.iconSvgIdTitle?.content?.iconThickness
      ?.value[0] || 'normal';

  return {
    anchorLabel,
    backgroundColor,
    htmlTagWrapper,
    marginTop,
    title,
    titleHeadingTag,
    titleIconId,
    titleIconThickness,
  };
};

// TODO: gestire estensioni non uguali al proprio mimetype (con una mappa?)
export const getExtensionFromMimeType = (text) => {
  if (typeof text !== 'string') {
    return;
  }
  const strings = text.split('/');

  return strings.length === 2 ? strings[1] : null;
};

export const getSEOValue = (obj) => {
  const item = obj || [];
  const settings = {
    ogTitle: item?.value?.ogTitle?.value,
    ogType: item?.value?.ogType?.value,
    ogDescription: item.value?.ogDescription?.value,
    ogImage: item?.value?.ogImageData?.node?.publicURL,
    metaRobots: item?.value?.metaRobots,
    ogUrl: item?.value?.ogUrl?.value,
    structuredDataJsonLd: item?.value?.structuredDataJsonLd?.value,
  };

  return settings;
};

export const setHeadContent = (contents) => {
  if (contents && Array.isArray(contents)) {
    return contents?.map((script, i) => {
      if (script.value) {
        try {
          const scriptStructure = JSON.parse(script.value);
          const Type = scriptStructure.type;
          const { attributes } = scriptStructure;
          const formattedAttributesArray = attributes?.map((attribute) => ({
            [attribute.name]: attribute.value || true,
          }));
          const formattedAttributesObj =
            formattedAttributesArray &&
            Object.assign({}, ...formattedAttributesArray);

          return (
            <Type {...formattedAttributesObj} key={i}>
              {scriptStructure['text-html']}
            </Type>
          );
        } catch (error) {
          console.error(error);
        }
      }

      return null;
    });
  }
};

export const parseJsonAttributes = (attributes) => {
  if (attributes) {
    try {
      const attributesFormatted = JSON.parse(attributes);
      return attributesFormatted;
    } catch (error) {
      console.error(error);
    }
  }
  return {};
};

// maps msoffice mimetypes to corresponding extensions to save some space
export const mapMimeTypeToExtension = (mimetype) => {
  const mapping = {
    'application/vnd.ms-excel': 'xls',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      'pptx',
    'application/msword': 'doc',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
      'docx',
  };
  return mapping[mimetype];
};
